<!-- Group together related form controls -->
<template>
    <div class="row">
        <div class="col-12 q-gutter-y-sm" :class="{ 'col-lg-7 col-md-10': !fullWidth }">
            <slot />
        </div>
    </div>
</template>

<script setup>
defineProps({ fullWidth: Boolean })
</script>
